<script>
  import bus from '@utils/bus'

  export default {
    data () {
      return {
        activeStep: 'personalData'
      }
    },
    mounted () {
      this.checkRouteName(this.$route.name)
      bus.$emit('hide-loader')
    },
    watch: {
      '$route.name': function (name) {
        this.checkRouteName(name)
      }
    },
    methods: {
      /**
       * Checa o name da rota atual para marcar como ativo a etapa da inscrição
       * @param name
       */
      checkRouteName (name) {
        switch (name) {
          case 'registration.store.personal':
            this.activeStep = 'personalData'
            break
          case 'registration.store.physical':
            this.activeStep = 'physicalData'
            break
          case 'registration.store.event':
            this.activeStep = 'eventData'
            break
          case 'registration.store.confirmation':
            this.activeStep = 'confirmationData'
            break
          default:
            this.activeStep = 'personalData'
        }
      }
    }
  }
</script>

<template>
    <div>
        <h1 class="title-steps">Etapas da Inscrição</h1>
        <div class="wizard">
            <div class="line"></div>
            <div class="item"
                 v-bind:class="{ '-active': activeStep === 'personalData' }">
                <i class="fa fa-user"></i>
                <span>Dados Pessoais</span>
            </div>
            <div class="line"></div>
            <div class="item"
                 v-bind:class="{ '-active': activeStep === 'physicalData' }">
                <i class="fa fa-lock"></i>
                <span>Dados Físicos</span>
            </div>
            <div class="line"></div>
            <div class="item"
                 v-bind:class="{ '-active': activeStep === 'eventData' }">
                <i class="fa fa-calendar"></i>
                <span>Dados do Evento</span>
            </div>
            <div class="line"></div>
            <div class="item"
                 v-bind:class="{ '-active': activeStep === 'confirmationData' }">
                <i class="fa fa-check"></i>
                <span>Confirmação</span>
            </div>
            <div class="line"></div>
        </div>
        <router-view></router-view>
    </div>
</template>
